/**
 * Service to manage changelog visibility based on app version
 * Uses localStorage to track which version the user has acknowledged
 */

const CHANGELOG_STORAGE_KEY = 'rondaybaciga_changelog_acknowledged';

class ChangelogService {
    /**
     * Get the version that user has acknowledged
     * @returns {string|null} The acknowledged version or null
     */
    getAcknowledgedVersion() {
        try {
            return localStorage.getItem(CHANGELOG_STORAGE_KEY);
        } catch (error) {
            console.error('Error reading acknowledged version from localStorage:', error);
            return null;
        }
    }

    /**
     * Set the version that user has acknowledged
     * @param {string} version - The version to mark as acknowledged
     */
    setAcknowledgedVersion(version) {
        try {
            localStorage.setItem(CHANGELOG_STORAGE_KEY, version);
        } catch (error) {
            console.error('Error saving acknowledged version to localStorage:', error);
        }
    }

    /**
     * Check if changelog should be shown for the current version
     * @param {string} currentVersion - The current app version
     * @returns {boolean} True if changelog should be shown
     */
    shouldShowChangelog(currentVersion) {
        if (!currentVersion) {
            return false;
        }

        const acknowledgedVersion = this.getAcknowledgedVersion();

        // Show if no version has been acknowledged or if current version is different
        return !acknowledgedVersion || acknowledgedVersion !== currentVersion;
    }

    /**
     * Mark changelog as acknowledged for current version
     * @param {string} currentVersion - The version to acknowledge
     */
    acknowledgeChangelog(currentVersion) {
        this.setAcknowledgedVersion(currentVersion);
    }

    /**
     * Clear acknowledged version (useful for testing or reset)
     */
    clearAcknowledgedVersion() {
        try {
            localStorage.removeItem(CHANGELOG_STORAGE_KEY);
        } catch (error) {
            console.error('Error clearing acknowledged version from localStorage:', error);
        }
    }
}

// Export singleton instance
const changelogService = new ChangelogService();
export default changelogService;
